@if(active) {
<div class="dialog-wrapper" [class.--is-open]="active">
  <div role="dialog" class="dialog" [class.--is-open]="ready">
    <div class="dialog__header">
      <h2 class="dialog__header__title">Detalhes da parada</h2>
      <button class="dialog__header__action" (click)="onClickClose()">
        <span class="pds-icon">close</span>
      </button>
    </div>
    <div class="dialog__content">
      <ng-content />
    </div>
  </div>
</div>
}
